import * as React from 'react';
import { toHex } from 'ui/common/hex-converter';
import { ComplexValue, ComponentProps } from 'ui/common';
import styles from 'app/area/case/components/fact-box/fact-box.scss';

interface ConnectedCasesFactBoxProps extends ComponentProps {
  connectedRiskArea?: ComplexValue<number>;
}
export const ConnectedCasesFactbox = (props: ConnectedCasesFactBoxProps) => {
  const bgColor = props.connectedRiskArea?.value && props.connectedRiskArea?.backgroundColor;
  return (
    <div id={props.componentId} className={`${props.className} ${styles.factBox}`}>
      <ul className={styles.factBoxItems} style={{ borderColor: toHex(bgColor) }}>
        {props.children}
      </ul>
    </div>
  );
};
